// 付费会员事件追踪
(function (global) {
  "use strict";

  var exposedKeys = {};

  function getRouteCategory(override) {
    if (override) return override;
    var doc = global.document;
    if (doc && doc.body) {
      if (doc.body.classList.contains("template-cart")) return "cart";
      if (doc.body.classList.contains("template-product")) return "productDetail";
    }
    if (global.utils && typeof global.utils.getRouteName === "function") {
      var route = global.utils.getRouteName();
      if (route && route !== "cartCheckout") return route;
    }
    var pathname = (global.location.pathname || "")
      .replace(/^\/+/, "")
      .replace(/\/+$/, "");
    return pathname || "other";
  }

  function pushEvent(en, el, ea, ec) {
    if (typeof global.dleCustomEvent !== "function") return;
    global.dleCustomEvent(en, el, ea, ec != null ? ec : getRouteCategory());
  }

  function normalizeButtonLabel(text) {
    var label = String(text || "").trim();
    return label || "button";
  }

  function trackOnce(key, fn) {
    if (exposedKeys[key]) return;
    exposedKeys[key] = true;
    fn();
  }

  function observeViewOnce(element, key, fn) {
    if (!element || exposedKeys[key]) return;
    if (typeof global.IntersectionObserver !== "function") {
      trackOnce(key, fn);
      return;
    }
    var observer = new global.IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.5) return;
          trackOnce(key, fn);
          observer.disconnect();
        });
      },
      { threshold: [0.5] }
    );
    observer.observe(element);
  }

  var CrownPassTracking = {
    getRouteCategory: getRouteCategory,
    pushEvent: pushEvent,
    normalizeButtonLabel: normalizeButtonLabel,
    observeViewOnce: observeViewOnce,
    resetExposureKeys: function () {
      exposedKeys = {};
    },

    trackPdpBannerView: function (isMember) {
      if (isMember) {
        pushEvent("pdp_isqueenCardArea", "PDP_isqueenCard-area", "view");
      } else {
        pushEvent("pdp_queenCardArea", "PDP_queenCard-area", "view");
      }
    },

    trackPdpBannerClick: function (isMember, buttonText) {
      var label = normalizeButtonLabel(buttonText);
      if (isMember) {
        pushEvent("pdp_isqueenCard", "PDP_isqueenCard::" + label, "click");
      } else {
        pushEvent("pdp_queenCard", "PDP_queenCard::" + label, "click");
      }
    },

    trackPdpMemberRightsPopupView: function (popupKind) {
      var suffix =
        popupKind === "checked"
          ? "MemberRightsChecked"
          : popupKind === "purchase_member"
            ? "MemberRightsPurchase"
            : "MemberRightsUnchecked";
      pushEvent("popUp", "Popup::" + suffix + "::view", "popup");
    },

    trackPdpMemberRightsPopupClick: function (popupKind, actionLabel) {
      var suffix =
        popupKind === "checked"
          ? "MemberRightsChecked"
          : popupKind === "purchase_member"
            ? "MemberRightsPurchase"
            : "MemberRightsUnchecked";
      var label = normalizeButtonLabel(actionLabel);
      pushEvent("popUp", "Popup::" + suffix + "::" + label, "popup_click");
    },

    trackCartModuleView: function () {
      pushEvent("cart_queenCardArea", "cart_queenCard-area", "view", "cart");
    },

    trackCartCheckboxClick: function (checked) {
      pushEvent(
        "cart_queenCard",
        "cart_queenCard::" + (checked ? "check" : "cancel"),
        "click",
        "cart"
      );
    },

    trackCartHelpClick: function () {
      pushEvent("help", "cart_queenCard::Help", "click", "cart");
    },

    trackCartMemberRightsPopupView: function (isMember) {
      var suffix = isMember ? "MemberRightsPurchase" : "MemberRightsUnpurchased";
      pushEvent("popUp", "Popup::" + suffix + "::view", "popup");
    },

    trackCartMemberRightsPopupClose: function (isMember) {
      var suffix = isMember ? "MemberRightsPurchase" : "MemberRightsUnpurchased";
      pushEvent("popUp", "Popup::" + suffix + "::close", "popup_click");
    },

    trackRetentionPopupView: function (routeCategory) {
      pushEvent(
        "popUp",
        "Popup::QueenCardDetainment::view",
        "popUp",
        routeCategory || getRouteCategory()
      );
    },

    trackRetentionPopupClick: function (buttonText, routeCategory) {
      pushEvent(
        "popUp",
        "Popup::QueenCardDetainment::" + normalizeButtonLabel(buttonText),
        "popUp_Click",
        routeCategory || getRouteCategory()
      );
    },

    trackRetentionPopupClose: function (routeCategory) {
      pushEvent(
        "popUp",
        "Popup::QueenCardDetainment::close",
        "popUp_Click",
        routeCategory || getRouteCategory()
      );
    },

    trackQueenCardSuccess: function (routeCategory) {
      pushEvent(
        "queenCard_success",
        "queenCard_success",
        "click",
        routeCategory || getRouteCategory()
      );
    },

    trackCheckoutModuleView: function () {
      pushEvent(
        "fireCheckout_queenCardArea",
        "fireCheckout_queenCard-area",
        "view",
        "order-confirm"
      );
    },

    trackCheckoutHelpClick: function () {
      pushEvent("help", "fireCheckout_queenCard::Help", "click", "order-confirm");
    },

    trackCheckoutCheckboxClick: function (checked) {
      pushEvent(
        "fireCheckout_QueenCard",
        "fireCheckout_queenCard::" + (checked ? "checked" : "cancel"),
        "click",
        "order-confirm"
      );
    },

    trackCheckoutMemberRightsPopupView: function (isMember) {
      var suffix = isMember ? "MemberRightsPurchase" : "MemberRightsUnpurchased";
      pushEvent(
        "popUp",
        "Popup::" + suffix + "::view",
        "popup",
        "order-confirm"
      );
    },

    trackCheckoutMemberRightsPopupClose: function (isMember) {
      var suffix = isMember ? "MemberRightsPurchase" : "MemberRightsUnpurchased";
      pushEvent(
        "popUp",
        "Popup::" + suffix + "::close",
        "popup_click",
        "order-confirm"
      );
    },

    trackCheckoutRetentionPopupView: function () {
      pushEvent(
        "popUp",
        "Popup::QueenCardDetainment::view",
        "popUp",
        "order-confirm"
      );
    },

    trackCheckoutRetentionPopupClick: function (buttonText) {
      pushEvent(
        "popUp",
        "Popup::QueenCardDetainment::" + normalizeButtonLabel(buttonText),
        "popUp_Click",
        "order-confirm"
      );
    },

    trackCheckoutRetentionPopupClose: function () {
      pushEvent(
        "popUp",
        "Popup::QueenCardDetainment::close",
        "popUp_Click",
        "order-confirm"
      );
    },

    trackCheckoutQueenCardSuccess: function () {
      pushEvent("queenCard_success", "queenCard_success", "click", "order-confirm");
    },

    /** Checkout UI extension sandbox — publish for GTM / custom pixel */
    publishCheckoutEvent: function (en, el, ea, ec) {
      var payload = {
        dlv_en: en,
        dlv_el: el,
        dlv_ea: ea,
        dlv_ec: ec || "order-confirm",
      };
      if (
        global.shopify &&
        global.shopify.analytics &&
        typeof global.shopify.analytics.publish === "function"
      ) {
        global.shopify.analytics.publish("crown_pass_custom_event", payload);
      }
    },
  };

  global.CrownPassTracking = CrownPassTracking;
})(typeof window !== "undefined" ? window : globalThis);
